import { render, staticRenderFns } from "./company-profile.vue?vue&type=template&id=5c1e52a4&scoped=true"
import script from "./company-profile.vue?vue&type=script&lang=js"
export * from "./company-profile.vue?vue&type=script&lang=js"
import style0 from "./company-profile.vue?vue&type=style&index=0&id=5c1e52a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1e52a4",
  null
  
)

export default component.exports